export default __webpack_public_path__ + "static/media/leftArrowHover.9a45ba25.png";